import styled from "styled-components";
import { Flex } from "antd";

const StyledContainer = styled(Flex)`
  article {
    border-bottom: 1px solid rgba(201, 200, 200, 0.5);
    display: flex;
    padding: 32px 32px 20px;
    gap: 44px;

    h5 {
      color: #1e1919;
      font-size: 16px;
      font-style: normal;
      margin: unset;
    }

    .container-left {
      display: flex;
      flex: 0 0 176px;
      flex-direction: column;
      gap: 10px;
      align-items: end;
    }

    .container-right {
      flex: 0 0 585px;
    }

    .ant-form-item {
      margin-bottom: 12px;
      width: 100%;
    }

    .ant-input-number-outlined,
    .ant-input-outlined {
      background: transparent;
      border-color: transparent;
      border-bottom: 1px solid #c9c8c8;
      border-radius: 0;
      color: #1e1919;
      width: 100%;
    }

    .ant-form-item .ant-form-item-label > label {
      color: #1e1919;
      font-size: 12px;
      font-weight: 400;
    }
  }

  .container-no-dependents {
    background: rgba(213, 225, 226, 0.3);
    border-radius: 8px;
    color: #1e1919;
    font-size: 12px;
    padding: 16px;
  }

  .item-dependent {
    background: rgba(213, 225, 226, 0.3);
    border-radius: 8px;
    padding: 16px;

    .ant-input-underlined.ant-input-disabled,
    .ant-input-underlined[disabled],
    .ant-input-number {
      background: transparent;
      color: #1e1919;
      padding-left: unset;
    }
  }
`;

export default StyledContainer;
